import React from "react";
import { graphql, useFragment } from "react-relay";

import { faCog } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import {
	MenuItemToBeDisabledForExternalWorkspaces,
	useGetPropsForExternalWorkspaces,
} from "~/meetings/MeetingHeader/MoreActionsMenu/MenuItemTooltip";
import { useStreamSettingsModal } from "~/stream/StreamSettings";

import type { SeriesSettings_note$key } from "~/__generated__/SeriesSettings_note.graphql";

const noteFragment = graphql`
	fragment SeriesSettings_note on Note {
		...MenuItemTooltip_useGetPropsForExternalWorkspaces_note
	}
`;

interface SeriesSettingsMenuItemProps {
	seriesId: string;
	note: SeriesSettings_note$key;
}

export default function SeriesSettingsMenuItem({ seriesId, note: noteKey }: SeriesSettingsMenuItemProps) {
	const note = useFragment(noteFragment, noteKey);
	const openStreamSettingsModal = useStreamSettingsModal(seriesId);
	const tooltipPropsForExternalWorkspaces = useGetPropsForExternalWorkspaces(note);

	return (
		<MenuItemToBeDisabledForExternalWorkspaces
			onSelect={openStreamSettingsModal}
			icon={faCog}
			{...tooltipPropsForExternalWorkspaces}
		>
			Settings…
		</MenuItemToBeDisabledForExternalWorkspaces>
	);
}
